import React from 'react';
import { string, object, node } from 'prop-types';
import classnames from 'classnames';
import Locale from '@active/react-utils/i18n/Locale';
import { interpolate } from '../../../../../../shared/utils/commonUtils';

const DEFAULT_VALUES = {
  mask: '****',
};

const translateField = (field, values = {}) => (
  typeof field === 'string' ? interpolate(field, { ...DEFAULT_VALUES, ...values }) : field
);

const StaticField = ({
  className, children, label,
  values,
}) => (
  children ? <div
    className={classnames(className, 'checkout-ui-component__payment-info__static-field')}>
    <div
      className="static-field-label">
      <Locale id={label} params={values}/>
    </div>
    <div
      className="static-field-value">
      {translateField(children, values)}
    </div>
  </div>
    : null
);

StaticField.propType = {
  label: string,
  children: node,
  values: object,
};

export default StaticField;
